(function ($) {


    $(window).resize(function () {
        if (this.resizeTO) clearTimeout(this.resizeTO);
        this.resizeTO = setTimeout(function () {
            $(this).trigger('resizeEnd');
        }, 1000);
    });


    $(document).ready(function () {


        function home_team_list_collapse() {

            var $grid = $('.team-list').isotope({
                layoutMode: 'fitRows'
            });
            var $group = $('#team-list-collapse');
            var $teamItem = $('.team-list .team-item');
            var $team_list = $('.team-list');
            var $team_info_collapse_width = 0;
            var $team_info_collapse = $('.team-info-collapse');
            var list_padding = 0;

            $(window).on('load resizeEnd', function () {

                $team_info_collapse_width = $team_list.outerWidth() - list_padding;

                $team_info_collapse.css({
                    'width': $team_info_collapse_width + 'px'
                });

                $('.team-list .team-item').each(function () {
                    var $this = $(this);
                    var $team_info_collapse = $this.find('.team-info-collapse');

                    $team_info_collapse.css({
                        'left': '-' + $this.css('left')
                    });

                    $team_info_collapse.css({
                        'display': 'block',
                        'visibility': 'hidden',
                        'height': 'auto'
                    });

                    var team_info_collapse_height = $team_info_collapse.css('height');

                    $this.find('.height-helper').css('height', team_info_collapse_height);

                    $team_info_collapse.css({
                        'display': '',
                        'visibility': ''
                    })

                });

                $grid.isotope('layout');

            });

            $group.on('show.bs.collapse', '.collapse', function () {
                $group.find('.collapse.in').collapse('hide');
            });

            $teamItem.on('show.bs.collapse', function () {
                $(this).addClass('open');
            });

            $teamItem.on('hide.bs.collapse', function () {
                $(this).removeClass('open');
            });

            $group.on('show.bs.collapse', '.collapse', function () {

                var $this_collapse = $(this);
                var $team_item = $this_collapse.closest('.team-item');
                var $height_helper = $team_item.find('.height-helper');

                $height_helper.css({
                    'display': 'block'
                });

                $grid.isotope('layout');

            });

            $group.on('hide.bs.collapse', '.collapse', function () {

                var $this_collapse = $(this);
                var $team_item = $this_collapse.closest('.team-item');
                var $height_helper = $team_item.find('.height-helper');

                $height_helper.css({
                    'display': 'none'
                });


                $grid.isotope('layout');
            });

            $group.on('shown.bs.collapse hidden.bs.collapse', '.collapse', function () {
                // clearInterval(layout_interval);
            });

        }

        home_team_list_collapse();

    })


})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/leadership.es6